import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./About.css";

function About() {
  const [activeCertificate, setActiveCertificate] = useState(null);

  const services = [
    {
      number: "01",
      title: "Software Development",
      text: "Custom software solutions designed around your business processes, requirements and future growth.",
      icon: "⌘",
    },
    {
      number: "02",
      title: "Web & Mobile",
      text: "Modern and responsive applications that deliver smooth digital experiences across devices.",
      icon: "◈",
    },
    {
      number: "03",
      title: "AI & Automation",
      text: "Intelligent solutions that automate repetitive work, improve productivity and unlock useful insights.",
      icon: "✦",
    },
    {
      number: "04",
      title: "Enterprise Solutions",
      text: "Connected business platforms that help organizations manage customers, teams, operations and data.",
      icon: "▦",
    },
  ];

  const journey = [
    {
      number: "01",
      title: "Discover",
      text: "Understand the business, users, challenges and goals before defining the right solution.",
    },
    {
      number: "02",
      title: "Design",
      text: "Convert requirements into clear workflows, experiences and technical plans.",
    },
    {
      number: "03",
      title: "Develop",
      text: "Build, integrate and test the solution with a strong focus on quality and usability.",
    },
    {
      number: "04",
      title: "Deliver & Grow",
      text: "Launch the solution and continuously improve it as the business evolves.",
    },
  ];

  const reasons = [
    {
      number: "01",
      title: "Business Understanding",
      text: "We focus on understanding the problem before selecting the technology.",
    },
    {
      number: "02",
      title: "Modern Technology",
      text: "We use practical and modern technologies to create scalable digital solutions.",
    },
    {
      number: "03",
      title: "Quality Focus",
      text: "Our development process focuses on reliability, usability and maintainability.",
    },
    {
      number: "04",
      title: "Long-Term Partnership",
      text: "We aim to become a technology partner, not simply a software vendor.",
    },
  ];

  const products = [
    {
      number: "01",
      category: "BUSINESS MANAGEMENT",
      title: "EasyFlow",
      text: "A connected platform for managing projects, tasks, teams, leads and quotations.",
    },
    {
      number: "02",
      category: "MANUFACTURING",
      title: "IndusFlow",
      text: "A manufacturing management platform providing visibility into machines, production and workforce.",
    },
    {
      number: "03",
      category: "AI SOLUTIONS",
      title: "Docparser AI",
      text: "AI-powered document processing that helps businesses extract and organize valuable information.",
    },
  ];

  const certificates = [
    {
      id: "iso",
      category: "QUALITY MANAGEMENT",
      title: "ISO 9001:2015",
      subtitle: "Quality Management System",
      text: "DNK Software holds ISO 9001:2015 certification associated with its quality management system for software development and IT allied services.",
    },
    {
      id: "mccia",
      category: "INDUSTRY ASSOCIATION",
      title: "MCCIA",
      subtitle: "Certificate of Associateship",
      text: "DNK Software is associated with the Mahratta Chamber of Commerce, Industries and Agriculture.",
    },
    {
      id: "dpiit",
      category: "STARTUP RECOGNITION",
      title: "DPIIT",
      subtitle: "Startup Recognition",
      text: "DNK Software has recognition under the Government of India's Department for Promotion of Industry and Internal Trade.",
    },
  ];

  return (
    <div className="dnk-about-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="dnk-about-hero">

        <div className="dnk-about-hero-pattern"></div>

        <div className="dnk-about-hero-orbit orbit-one"></div>
        <div className="dnk-about-hero-orbit orbit-two"></div>

        <div className="container">

          <div className="dnk-about-hero-inner">

            <div className="dnk-about-hero-text">

              <span className="dnk-about-label">
                ABOUT DNK SOFTWARE
              </span>

              <h1>
                Technology Built
                <br />
                Around Your Business.
              </h1>

              <p>
                DNK Software Pvt Ltd develops practical digital solutions
                that help businesses simplify operations, improve
                productivity and create better customer experiences.
              </p>

              <div className="dnk-about-hero-buttons">

                <Link
                  to="/contact"
                  className="dnk-gold-button"
                >
                  Talk To Our Team
                  <span>→</span>
                </Link>

                <Link
                  to="/products"
                  className="dnk-light-button"
                >
                  Explore Products
                </Link>

              </div>

            </div>

            {/* <div className="dnk-about-hero-side">

              <div className="dnk-hero-card">

                <span className="dnk-hero-card-small">
                  OUR APPROACH
                </span>

                <h3>
                  Understand.
                  <br />
                  Build.
                  <br />
                  Improve.
                </h3>

                <div className="dnk-hero-line"></div>

                <p>
                  Connecting business thinking with technology.
                </p>

              </div> */}

            {/* </div> */}

          </div>

        </div>

      </section>


      {/* =====================================================
          COMPANY STORY
      ===================================================== */}

      <section className="dnk-about-story">

        <div className="container">

          <div className="row align-items-center">

            <div className="col-lg-6 col-12">

              <div className="dnk-story-content">

                <span className="dnk-section-label">
                  OUR STORY
                </span>

                <h2>
                  We Don't Just
                  <br />
                  Build Software.
                  <br />
                  We Solve Problems.
                </h2>

                <p className="dnk-story-highlight">
                  At DNK Software Pvt Ltd, we're passionate about using
                  technology to solve complex business problems.
                </p>

                <p>
                  We work with businesses to understand their unique
                  requirements and turn those requirements into useful,
                  reliable and scalable digital solutions.
                </p>

                <p>
                  Our expertise spans custom software development,
                  web and mobile applications, AI solutions and
                  enterprise platforms.
                </p>

                <div className="dnk-story-points">

                  <div>
                    <span>✓</span>
                    <p>Business-focused solutions</p>
                  </div>

                  <div>
                    <span>✓</span>
                    <p>Modern and scalable technology</p>
                  </div>

                  <div>
                    <span>✓</span>
                    <p>Quality-driven development</p>
                  </div>

                </div>

              </div>

            </div>


            <div className="col-lg-6 col-12">

              <div className="dnk-story-image-wrapper">

                <div className="dnk-story-image">

                  <img
                    src={require("../assets/services-1.jpg")}
                    alt="DNK Software technology solutions"
                  />

                </div>

                <div className="dnk-story-floating">

                  <strong>DNK</strong>

                  <span>
                    Software & Digital Solutions
                  </span>

                </div>

                <div className="dnk-story-decoration"></div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHAT WE DO
      ===================================================== */}

      <section className="dnk-about-services">

        <div className="container">

          <div className="dnk-section-header">

            <div>

              <span className="dnk-section-label">
                WHAT WE DO
              </span>

              <h2>
                Technology That
                <br />
                Creates Business Value.
              </h2>

            </div>

            <p>
              From custom applications to intelligent automation,
              we combine technology and business understanding to
              create solutions that make a difference.
            </p>

          </div>


          <div className="row">

            {services.map((service) => (

              <div
                className="col-lg-3 col-md-6 col-12"
                key={service.number}
              >

                <div className="dnk-service-card">

                  <div className="dnk-service-card-top">

                    <span className="dnk-service-number">
                      {service.number}
                    </span>

                    <span className="dnk-service-icon">
                      {service.icon}
                    </span>

                  </div>

                  <h3>
                    {service.title}
                  </h3>

                  <p>
                    {service.text}
                  </p>

                  <div className="dnk-service-arrow">
                    →
                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* =====================================================
          JOURNEY
      ===================================================== */}

      <section className="dnk-about-journey">

        <div className="container">

          <div className="dnk-journey-heading">

            <span className="dnk-section-label">
              OUR JOURNEY
            </span>

            <h2>
              From A Business Challenge
              <br />
              To A Working Solution.
            </h2>

            <p>
              Our approach keeps the business objective at the center
              of every technology decision.
            </p>

          </div>


          <div className="dnk-journey-wrapper">

            {journey.map((item, index) => (

              <div
                className="dnk-journey-step"
                key={item.number}
              >

                <div className="dnk-journey-step-number">
                  {item.number}
                </div>

                <div className="dnk-journey-step-content">

                  <span>
                    STEP {index + 1}
                  </span>

                  <h3>
                    {item.title}
                  </h3>

                  <p>
                    {item.text}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY DNK
      ===================================================== */}

      <section className="dnk-about-why">

        <div className="container">

          <div className="row">

            <div className="col-lg-5 col-12">

              <div className="dnk-why-heading">

                <span className="dnk-section-label">
                  WHY DNK SOFTWARE
                </span>

                <h2>
                  A Technology
                  <br />
                  Partner For Growth.
                </h2>

                <p>
                  We believe successful software is not only about
                  writing code. It is about understanding people,
                  processes and business goals.
                </p>

                <Link
                  to="/services"
                  className="dnk-about-link"
                >
                  Explore Our Services
                  <span>→</span>
                </Link>

              </div>

            </div>


            <div className="col-lg-7 col-12">

              <div className="dnk-why-grid">

                {reasons.map((reason) => (

                  <div
                    className="dnk-why-card"
                    key={reason.number}
                  >

                    <span className="dnk-why-number">
                      {reason.number}
                    </span>

                    <div className="dnk-why-check">
                      ✓
                    </div>

                    <h3>
                      {reason.title}
                    </h3>

                    <p>
                      {reason.text}
                    </p>

                  </div>

                ))}

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          PRODUCTS
      ===================================================== */}

      <section className="dnk-about-products">

        <div className="container">

          <div className="dnk-section-header">

            <div>

              <span className="dnk-section-label">
                OUR PRODUCTS
              </span>

              <h2>
                Products Built
                <br />
                For Real Business Needs.
              </h2>

            </div>

            <p>
              Alongside custom software development, DNK Software
              is building products that solve practical business
              and operational challenges.
            </p>

          </div>


          <div className="dnk-products-list">

            {products.map((product) => (

              <Link
                to="/products"
                className="dnk-product-row"
                key={product.number}
              >

                <span className="dnk-product-number">
                  {product.number}
                </span>

                <div className="dnk-product-info">

                  <span>
                    {product.category}
                  </span>

                  <h3>
                    {product.title}
                  </h3>

                  <p>
                    {product.text}
                  </p>

                </div>

                <div className="dnk-product-arrow">
                  →
                </div>

              </Link>

            ))}

          </div>


          <div className="dnk-products-action">

            <Link
              to="/products"
              className="dnk-dark-button"
            >
              View All Products
              <span>→</span>
            </Link>

          </div>

        </div>

      </section>


      {/* =====================================================
          CERTIFICATIONS
      ===================================================== */}

      <section className="dnk-about-certifications">

        <div className="container">

          <div className="dnk-cert-header">

            <span className="dnk-section-label">
              CERTIFICATIONS & RECOGNITIONS
            </span>

            <h2>
              Built On Quality.
              <br />
              Recognized With Trust.
            </h2>

            <p>
              Our certifications and recognitions reflect our commitment
              to quality, professional standards and responsible growth.
            </p>

          </div>


          <div className="row">

            {certificates.map((certificate) => (

              <div
                className="col-lg-4 col-md-6 col-12"
                key={certificate.id}
              >

                <div className="dnk-cert-card">

                  <div className="dnk-cert-top">

                    <span>
                      {certificate.category}
                    </span>

                    <b>
                      ✓
                    </b>

                  </div>


                  <div className="dnk-cert-symbol">
                    ✓
                  </div>


                  <h3>
                    {certificate.title}
                  </h3>

                  <h4>
                    {certificate.subtitle}
                  </h4>

                  <p>
                    {certificate.text}
                  </p>


                  {/* <button
                    type="button"
                    className="dnk-cert-button"
                    onClick={() =>
                      setActiveCertificate(certificate)
                    }
                  >
                    View Details
                    <span>→</span>
                  </button> */}

                </div>

              </div>

            ))}

          </div>


          {/* <div className="dnk-cert-message">

            <span>✦</span>

            <p>
              Official certificate images can be displayed here after
              the final certificate files are uploaded.
            </p>

          </div> */}

        </div>

      </section>


      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="dnk-about-final">

        <div className="dnk-final-circle final-one"></div>
        <div className="dnk-final-circle final-two"></div>

        <div className="container">

          <div className="dnk-final-content">

            <span className="dnk-section-label">
              LET'S WORK TOGETHER
            </span>

            {/* <h2>
              Have A Business
              <br />
              Challenge?
            </h2>

            <p>
              Let's turn your business challenge into a practical
              technology solution.
            </p> */}

            {/* <div className="dnk-final-buttons">

              <Link
                to="/contact"
                className="dnk-gold-button"
              >
                Talk To Our Team
                <span>→</span>
              </Link>

              <Link
                to="/services"
                className="dnk-light-button"
              >
                Explore Services
              </Link>

            </div> */}

          </div>

        </div>

      </section>


      {/* =====================================================
          CERTIFICATE MODAL
      ===================================================== */}

      {activeCertificate && (

        <div
          className="dnk-cert-modal"
          onClick={() => setActiveCertificate(null)}
        >

          <div
            className="dnk-cert-modal-box"
            onClick={(event) => event.stopPropagation()}
          >

            <button
              type="button"
              className="dnk-cert-close"
              onClick={() => setActiveCertificate(null)}
            >
              ×
            </button>

            <span className="dnk-section-label">
              {activeCertificate.category}
            </span>

            <h2>
              {activeCertificate.title}
            </h2>

            <h4>
              {activeCertificate.subtitle}
            </h4>

            <div className="dnk-cert-image-placeholder">

              <span>✓</span>

              {/* <p>
                Official certificate image will be added here.
              </p> */}

            </div>

            <p className="dnk-modal-description">
              {activeCertificate.text}
            </p>

          </div>

        </div>

      )}

    </div>
  );
}

export default About;